import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUserPlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill="#000"
      d="M5.554.57a2.885 2.885 0 1 1 0 5.77 2.885 2.885 0 0 1 0-5.77m0 4.914a2.028 2.028 0 1 0 0-4.057 2.028 2.028 0 0 0 0 4.057M1.34 11.448l-.84-.172.4-1.982c.45-2.19 2.362-3.815 4.653-3.816h.007c1.09 0 2.093.372 2.89.995l-.01-.007-.527.675a3.8 3.8 0 0 0-2.352-.806h-.007a3.9 3.9 0 0 0-3.81 3.104l-.004.026zM9.644 6.02a3.702 3.702 0 1 1 0 7.405 3.702 3.702 0 0 1 0-7.405m0 6.548a2.845 2.845 0 1 0 0-5.691 2.845 2.845 0 0 0 0 5.69m1.64-2.417H8.01v-.857h3.274zm-1.211 1.211h-.857V8.09h.857z"
    />
  </svg>
);
export default SvgUserPlusIcon;
